var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.36 19.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "save",
    d: "M18.753,6.482,15.128,2.857a2.074,2.074,0,0,0-1.466-.607H2.074A2.074,2.074,0,0,0,0,4.324V19.536A2.074,2.074,0,0,0,2.074,21.61H17.286a2.074,2.074,0,0,0,2.074-2.074V7.949a2.074,2.074,0,0,0-.608-1.466ZM9.68,18.845a2.766,2.766,0,1,1,2.766-2.766A2.766,2.766,0,0,1,9.68,18.845Zm4.149-13.16v4.344a.519.519,0,0,1-.519.519H3.285a.519.519,0,0,1-.519-.519V5.534a.519.519,0,0,1,.519-.519H13.16a.52.52,0,0,1,.367.152l.151.151A.518.518,0,0,1,13.829,5.684Z",
    transform: "translate(0 -2.25)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.177860504fe4d794c62bbd2e43597a6a.svg";
export { ForwardRef as ReactComponent };